/** SteamID64 (17 dígitos, prefixo 7656119…). */
const STEAM64_RE = /^7656119\d{10}$/;

/**
 * @param {string} raw
 * @returns {string | null}
 */
export function normalizeSteamId(raw) {
    const s = String(raw ?? "").trim().replace(/\s/g, "");
    if (!s) return null;
    if (STEAM64_RE.test(s)) return s;
    return null;
}

/**
 * @param {string} raw
 */
export function isValidSteamId(raw) {
    return normalizeSteamId(raw) != null;
}

/** URL pública do perfil Steam (SteamID64). */
export function steamProfileUrl(steamId) {
    const id = normalizeSteamId(steamId);
    if (!id) return null;
    return `https://steamcommunity.com/profiles/${id}`;
}
